module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("How to Negotiate"), _c('br'), _vm._v(" the Crucibles of Life"), _c('br'), _vm._v(" not Somehow but"), _c('br'), _vm._v(" Triumphantly")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_c('b', [_vm._v("About the Author")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_c('b', [_vm._v("Dedication")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_c('b', [_vm._v("Copyright Information ©")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#preface"
    }
  }, [_c('b', [_vm._v("Preface")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#part-1-the-crucible-of-life"
    }
  }, [_c('b', [_vm._v("Part 1: The Crucible of Life")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#chapter-1-before-the-beginning"
    }
  }, [_c('i', [_vm._v("Chapter 1: Before the Beginning")])]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#the-universe"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#humankind"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#chapter-2-in-the-beginning"
    }
  }, [_c('i', [_vm._v("Chapter 2: In the Beginning")])]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#the-crucible-of-life-started"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#part-2-the-crucibles-of-life",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Part 2: The Crucibles of Life")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#chapter-3-dual-citizenship",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Chapter 3: Dual Citizenship")])]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#the-death-of-my-father",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#forward-40-years-diagnosis-terminal",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#chapter-4-more-than-belief",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Chapter 4: More Than Belief")])]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#i-believe.-help-my-unbelief.",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#ultimate-control",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#gods-way-is-not-our-way",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#gods-timing-is-not-our-timing",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#when-is-enough-enough",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#ours-is-not-to-understand",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#can-we-be-a-change-agent",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#so-what-of-the-consequences",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#chapter-5-faith-works",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Chapter 5: Faith Works")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#chapter-6-faith-talk",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Chapter 6: Faith Talk")])]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#sit-or-move",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#a-missed-opportunity",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#a-response-to-a-partial-leading",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#a-response-when-one-is-not-willing",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#an-unwavering-faith",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#kosovo",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#overwhelmed",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#chapter-7-two-dimensional",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Chapter 7: Two Dimensional")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#chapter-8-the-blueprint-for-life",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Chapter 8: The Blueprint for Life")])]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#the-future",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#peace",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#chapter-9-relationships",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Chapter 9: Relationships")])]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#to-love-god",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#to-love-others",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#love-not-like",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#a-shining-light",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#action-required",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#no-regrets",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#be-normal",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#be-accepting",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#chapter-10-thought-matters",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Chapter 10: Thought Matters")])]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#do-everything-in-love",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#control",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-49"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#chapter-11-heaven-can-wait",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Chapter 11: Heaven Can Wait")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-50"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Epilogue")])]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-51"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#life",
      "title": "Link target outside of Sample"
    }
  })])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0